import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import InputMask from 'react-input-mask';
import Select from 'react-select';
import Toggle from 'react-toggle';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';

class LocationsEdit extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      id: null,
      name: null,
      icao_code: null,
      iata_code: null,
      city: null,
      coordinate_lat: null,
      coordinate_long: null,
      shore: null,
      location_type_id: null,
      class: null,
      group: null,
      country_id: null,
      location_types_select: [],
      countries_select: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.locale = getLocale();

    this.loadData = this.loadData.bind(this);
    this.edit = this.edit.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/local/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/locais');
        if (responseJson.status === 'success') {
          self.setState({
            id: responseJson.data.main.id,
            name: responseJson.data.main.name,
            icao_code: responseJson.data.main.icao_code,
            iata_code: responseJson.data.main.iata_code,
            city: responseJson.data.main.city,
            coordinate_lat: responseJson.data.main.coordinate_lat,
            coordinate_long: responseJson.data.main.coordinate_long,
            shore: responseJson.data.main.shore,
            location_type_id: responseJson.data.main.location_type_id,
            class: responseJson.data.main.class,
            group: responseJson.data.main.group,
            country_id: responseJson.data.main.country_id,
            location_types_select: responseJson.data.location_types_select,
            countries_select: responseJson.data.countries_select,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      });
    });
  }

  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      name: this.state.name,
      icao_code: this.state.icao_code,
      iata_code: this.state.iata_code,
      city: this.state.city,
      coordinate_lat: this.state.coordinate_lat,
      coordinate_long: this.state.coordinate_long,
      shore: this.state.shore,
      location_type_id: this.state.location_type_id,
      class: this.state.class,
      group: this.state.group,
      country_id: this.state.country_id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/local', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }


  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Locais.EditarLocal.titulo}</h3>
      <Link to="/locais" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.edit}>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.Locais.EditarLocal.formulario.Nome}:</label>
            <input type="text" className="form-control" name="name" value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
          </div>
          <div className="col-md-6 form-group">
            <label>{this.locale.Locais.EditarLocal.formulario.CodigoICAO}:</label>
            <input type="text" className="form-control" name="icao_code" value={this.state.icao_code} onChange={this.handleChange.bind(this, 'icao_code')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.Locais.EditarLocal.formulario.Cidade}:</label>
            <input type="text" className="form-control" name="city" value={this.state.city} onChange={this.handleChange.bind(this, 'city')} />
          </div>
          <div className="col-md-6 form-group">
            <label>{this.locale.Locais.EditarLocal.formulario.Shore}:</label>
            <Select
              className="form-field-name"
              name="shore"
              value={this.state.shore}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'shore')}
              options={[
                  {value: 'On-Shore', label: this.locale.Locais.EditarLocal.formulario.opcoesShore.OnShore},
                  {value: 'Off-Shore', label: this.locale.Locais.EditarLocal.formulario.opcoesShore.OffShore},
              ]}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.Locais.EditarLocal.formulario.Latitude}:</label>
            <input type="text" className="form-control" name="coordinate_lat" value={this.state.coordinate_lat} onChange={this.handleChange.bind(this, 'coordinate_lat')} />
          </div>
          <div className="col-md-6 form-group">
            <label>{this.locale.Locais.EditarLocal.formulario.Longitude}:</label>
            <input type="text" className="form-control" name="coordinate_long" value={this.state.coordinate_long} onChange={this.handleChange.bind(this, 'coordinate_long')} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.Locais.EditarLocal.formulario.CodigoIATA}:</label>
            <input type="text" name="iata_code" className="form-control" placeholder={this.locale.Locais.EditarLocal.formulario.placeholder.CodigoIATA} value={this.state.iata_code} onChange={this.handleChange.bind(this, 'iata_code')} />
          </div>
          <div className="col-md-6 form-group">
            <label>{this.locale.Locais.EditarLocal.formulario.Tipo}:</label>
            <Select
              className="form-field-name"
              name="location_type_id"
              value={this.state.location_type_id}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'location_type_id')}
              options={this.state.location_types_select}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.Locais.EditarLocal.formulario.Grupo}:</label>
            <Select
              className="form-field-name"
              name="group"
              value={this.state.group}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'group')}
              options={[
                {value: '1', label: '1'},
                {value: '2', label: '2'},
                {value: '3', label: '3'},
              ]}
            />
          </div>
          <div className="col-md-6 form-group">
            <label>{this.locale.Locais.EditarLocal.formulario.Classe}:</label>
            <Select
              className="form-field-name"
              name="class"
              value={this.state.class}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'class')}
              options={[
                {value: 'A', label: 'A'},
                {value: 'B', label: 'B'},
                {value: 'C', label: 'C'},
                {value: 'D', label: 'D'},
                {value: 'E', label: 'E'},
                {value: 'F', label: 'F'},
              ]}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.Locais.EditarLocal.formulario.Pais}:</label>
            <Select
              className="form-field-name"
              name="country_id"
              value={this.state.country_id}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'country_id')}
              options={this.state.countries_select}
              required
            />
          </div>
        </div>
        <hr/>
        <button type={'submit'} className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.general.salvar}</button>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default LocationsEdit;



// WEBPACK FOOTER //
// ./src/Components/Locations/LocationsEdit.js